module.exports = __webpack_public_path__ + "img/recipe2.c5672327.svg";